module.exports = __webpack_public_path__ + "img/swaminm.dfefb970.jpg";